document.addEventListener('DOMContentLoaded', () => {
  const main = document.querySelector('[data-ht-gallery-main]');
  const thumbs = Array.from(document.querySelectorAll('[data-ht-gallery-thumb]'));
  const prev = document.querySelector('[data-ht-gallery-prev]');
  const next = document.querySelector('[data-ht-gallery-next]');
  if (!main || !thumbs.length) return;

  let currentIdx = 0;

  const setActive = (i) => {
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIdx = i;
    const thumb = thumbs[i];
    const fullSrc = thumb.dataset.fullSrc || thumb.querySelector('img').src;
    main.src = fullSrc;
    thumbs.forEach((t, j) => {
      t.classList.toggle('active', j === i);
    });
  };

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => setActive(i));
  });
  if (prev) prev.addEventListener('click', (e) => { e.stopPropagation(); setActive(currentIdx - 1); });
  if (next) next.addEventListener('click', (e) => { e.stopPropagation(); setActive(currentIdx + 1); });

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') setActive(currentIdx - 1);
    if (e.key === 'ArrowRight') setActive(currentIdx + 1);
  });

  // lightbox on main image click
  main.addEventListener('click', () => {
    const overlay = document.createElement('div');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-label', 'Product photo full size');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(5,3,10,0.94);z-index:9999;display:flex;align-items:center;justify-content:center;cursor:zoom-out;';
    const img = document.createElement('img');
    img.src = main.src;
    img.style.cssText = 'max-width:95vw;max-height:95vh;object-fit:contain;';
    overlay.appendChild(img);
    overlay.addEventListener('click', () => overlay.remove());
    const escHandler = (e) => {
      if (e.key === 'Escape') { overlay.remove(); document.removeEventListener('keydown', escHandler); }
    };
    document.addEventListener('keydown', escHandler);
    document.body.appendChild(overlay);
  });
});
